import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=2e970092&scoped=true&"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryModal.vue?vue&type=style&index=0&id=2e970092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e970092",
  null
  
)

export default component.exports